export const ALERTS_NEW_SUCCESS = 'ALERTS_NEW_SUCCESS';
export const ALERTS_CLEAR = 'ALERTS_CLEAR';
